/**
 * Browser storage keys used by the admin app.
 * Centralizing keys avoids hard-coded strings across files.
 */
export const STORAGE_KEYS = {
  adminToken: 'admin_token',
  adminLanguage: 'admin_language',
} as const;

